(() => {
  window.swinger.eventHub.register('click', '.swinger-address-book__button--back', () => {
    window.history.back();
  });
})();
